<template>
  <basic-container>
    <div style="padding: 1rem 0">
      项目名称:
      <el-select @change="changeProject" v-model="projectId">
        <el-option
          v-for="(item, index) in projectList"
          :key="index"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </div>
    <el-table 
    :data="contractAlertList" 
    :key="mainTableKey"
    :loading="showLoading"
    >
    
    <!-- v-if="showTable" -->
      <el-table-column prop="notifyType" label="提醒类型">
        <template slot-scope="scope">
          <el-tag type="success">
            {{ getDic(scope.row.notifyType) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="notifyFlag" label="是否提醒">
        <template slot-scope="scope">
          <el-switch
            @change="updateRow(scope.row)"
            v-model="scope.row.notifyFlag_"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="notifyCount" label="提醒次数">
        <template slot-scope="scope">
          <div v-if="scope.row.notifyAdvanceDay > 0">
            <el-input
              v-model="scope.row.notifyCount"
              @input="filterInput(scope, 'notifyCount')"
              maxlength="3"
              style="width: 80px"
            ></el-input>
          </div>
          <div v-else>
            {{ scope.row.notifyCount }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="notifyCycle" label="提醒周期/小时">
        <template slot-scope="scope">
          <div v-if="scope.row.notifyAdvanceDay > 0">
            <el-input
              v-model="scope.row.notifyCycle"
              @input="filterInput(scope, 'notifyCycle')"
              maxlength="3"
              style="width: 80px"
            ></el-input>
          </div>
          <div v-else>
            {{ scope.row.notifyCycle }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="notifyUserIds" label="提醒人">
        <template slot-scope="scope">
          <el-input
            readonly
            v-model="scope.row.userIds"
            style="display: none"
          ></el-input>
          合同负责人,
          <el-input
            @focus="editUserBox(scope.row)"
            v-model="scope.row.userNames"
            autosize
            type="textarea"
          ></el-input>
          <!-- <div>
            合同负责人,
            <el-select
              @change="changeProjectUser(scope.row)"
              v-model="scope.row.notifyUserIds_"
              multiple
            >
              <el-option
                v-for="(item, index) in notifyUserList"
                :key="index"
                :label="item.realName"
                :value="item.id"
              ></el-option>
            </el-select>
          </div> -->
        </template>
      </el-table-column>
      <el-table-column prop="notifyAdvanceDay" label="提醒时间">
        <template slot-scope="scope">
          <div
            v-if="
              scope.row.notifyAdvanceDay_ > 0 ||
              scope.row.notifyAdvanceDay_ < 0 ||
              (scope.row.notifyAdvanceDay_ + '').toString() === 'null'
            "
          >
            提前
            <el-input
              v-model="scope.row.notifyAdvanceDay"
              @blur="filterInput(scope, 'notifyAdvanceDay')"
              maxlength="3"
              style="width: 80px"
            ></el-input>
            天推送
          </div>
          <div v-else-if="scope.row.notifyAdvanceDay_ == 0">实时通知</div>
          <!-- <div v-else-if="scope.row.notifyAdvanceDay<0 || scope.row.notifyAdvanceDay.toString() === 'null'">
                        提前
                        <el-input v-model="scope.row.notifyAdvanceDay" @input="filterInput(scope,'notifyAdvanceDay')" maxlength="3" style="width:80px;"></el-input>
                        天推送
                    </div> -->
        </template>
      </el-table-column>
      <el-table-column prop="sys" label="系统提醒">
        <template slot-scope="scope">
          <el-switch @change="updateRow(scope.row, 1)" v-model="scope.row.sys">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="wx" label="微信提醒">
        <template slot-scope="scope">
          <el-switch @change="updateRow(scope.row, 3)" v-model="scope.row.wx">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="text" label="短信提醒">
        <template slot-scope="scope">
          <el-switch @change="updateRow(scope.row, 2)" v-model="scope.row.text">
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
    <!-- 人员选择 -->
    <el-dialog
      title="请选择人员"
      :visible.sync="dialogUserEditBoxVisible"
      append-to-body
      :modal-append-to-body="false"
      width="80%"
    >
      <user-edit-box
        v-if="dialogUserEditBoxVisible && userEditBoxProjectId"
        @closeAction="handleCloseAction"
        @submitAction="handleSubmitAction"
        @editAction="handleEditAction"
        :selectType="selectUserType"
        :handleAction="handleAction"
        :remainUserListInside="remainUserList"
        :projectId="userEditBoxProjectId"
      />
    </el-dialog>
  </basic-container>
</template>
<script>
import {
  getList,
  getProjectList,
  updateRow,
  getDictionary,
  getProjectUserList,
  getInitList,
} from "@/api/crmedical/contract/alert/alert";

import userEditBox from "@/views/crmedical/group/user-edit-box";

export default {
  components: { userEditBox },
  data() {
    return {
      showLoading:false,
      mainTableKey:1,
      //人员选择
      dialogUserEditBoxVisible: false, //显隐
      userEditBoxProjectId: "", //项目id
      selectUserType: "",
      remainUserList: [],
      handleAction: "",
      currentRow: {},
      //人员选择end
      contractNotifyTypeList: [],
      projectId: "",
      showTable: false,
      projectList: [],
      contractAlertList: [
        {
          notifyFlag: true,
        },
      ],
    };
  },
  activated() {
    console.log("activated!!!!!=============");
    this.changeProject(this.projectId);
  },

  created() {
    // contract_notify_type
    getDictionary({ code: "contract_notify_type" }).then((res) => {
      console.log(res.data);
      this.contractNotifyTypeList = res.data;
    });
    getProjectList().then((res) => {
      this.projectList = res.data;
      this.projectId = this.projectList[0].id;

      getList({ projectId: this.projectList[0].id }).then((res) => {
        console.log(res);
        if (res.data.records.length > 0) {
          this.contractAlertList = res.data.records;

          this.contractAlertList.forEach((ele, index) => {
            this.contractAlertList[index].notifyFlag_ = this.transferBoolean(
              this.contractAlertList[index].notifyFlag
            );
            this.contractAlertList[index].wx = this.getWx(
              this.contractAlertList[index].notifyWays
            );
            this.contractAlertList[index].sys = this.getSys(
              this.contractAlertList[index].notifyWays
            );
            this.contractAlertList[index].text = this.getText(
              this.contractAlertList[index].notifyWays
            );
            // this.contractAlertList[index].notifyAdvanceDay = 1
            this.contractAlertList[
              index
            ].notifyAdvanceDay_ = this.contractAlertList[
              index
            ].notifyAdvanceDay;
            this.contractAlertList[
              index
            ].notifyUserIds_ = this.getNotifyUserIds(
              this.contractAlertList[index].notifyUserIds
            );
          });
          console.log(this.contractAlertList);

          getProjectUserList({ projectId: this.projectList[0].id }).then(
            (res) => {
              console.log(res);
              this.notifyUserList = res.data;
              this.contractAlertList = this.deepClone(this.contractAlertList);
              this.contractAlertList = this.addUserInfo(
                this.contractAlertList,
                this.notifyUserList
              );
              this.showTable = true;
              this.mainTableKey = Math.random();
            }
          );
        } else {
          getInitList({ projectId: this.projectList[0].id }).then(
            (response) => {
              this.contractAlertList = response.data;
              this.contractAlertList.forEach((ele, index) => {
                this.contractAlertList[
                  index
                ].notifyFlag_ = this.transferBoolean(
                  this.contractAlertList[index].notifyFlag
                );
                this.contractAlertList[index].wx = this.getWx(
                  this.contractAlertList[index].notifyWays
                );
                this.contractAlertList[index].sys = this.getSys(
                  this.contractAlertList[index].notifyWays
                );
                this.contractAlertList[index].text = this.getText(
                  this.contractAlertList[index].notifyWays
                );
                // this.contractAlertList[index].notifyAdvanceDay = 1
                this.contractAlertList[
                  index
                ].notifyAdvanceDay_ = this.contractAlertList[
                  index
                ].notifyAdvanceDay;
                this.contractAlertList[
                  index
                ].notifyUserIds_ = this.getNotifyUserIds(
                  this.contractAlertList[index].notifyUserIds
                );
              });
              console.log(this.contractAlertList);
              getProjectUserList({ projectId: this.projectList[0].id }).then(
                (res) => {
                  console.log(res);
                  this.notifyUserList = res.data;
                  this.contractAlertList = this.deepClone(
                    this.contractAlertList
                  );
                  this.contractAlertList = this.addUserInfo(
                    this.contractAlertList,
                    this.notifyUserList
                  );
                  this.showTable = true;
              this.mainTableKey = Math.random();
                }
              );
            }
          );
        }
      });
    });
  },
  methods: {
    //人员选择器
    handleCloseAction(val) {
      this.dialogUserEditBoxVisible = false;
    },
    handleSubmitAction(val) {},
    handleEditAction(val) {
      console.log("val==>", val);
      this.currentRow.userIds = val.idListString;
      this.currentRow.userNames = val.nameListString;
      this.changeProjectUser(this.currentRow);
      this.dialogUserEditBoxVisible = false;
    },
    editUserBox(row) {
      this.currentRow = row;
      this.userEditBoxProjectId = row.projectId;
      this.selectUserType = 1;
      this.handleAction = 2;
      this.remainUserList = row.userItems;
      console.log("row==>", row);
      this.dialogUserEditBoxVisible = true;
    },
    addUserInfo(list, dicts) {
      list.forEach((item) => {
        let userNames = [];
        let userItems = [];
        dicts.forEach((item2) => {
          if (item.notifyUserIds_.includes(item2.id)) {
            userNames.push(item2.realNameAndPhone);
            userItems.push(item2);
          }
        });
        item.userNames = userNames.join(",");
        item.userItems = userItems;
        item.userIds = item.notifyUserIds_;
      });
      return list;
    },
    //人员选择器end
    getNotifyUserIds(list) {
      let arr = [];
      console.log(list);
      if (list.split(",").length > 0) {
        list.split(",").forEach((element) => {
          if (element) {
            arr.push(element);
          }
        });
        // arr = list;
      }
      return arr;
    },
    getNotifyUserIds_(list) {
      let arr = [];
      if (list.length > 1) {
        arr = list.join(",");
      } else {
        arr = list.join("");
      }
      return arr;
    },
    getDic(val) {
      let type = "";
      this.contractNotifyTypeList.forEach((ele, index) => {
        if (parseInt(ele.dictKey) == parseInt(val)) {
          type = ele.dictValue;
        }
      });
      return type;
    },
    filterInput(scope, index) {
      console.log("666");
      // scope.row[index] = scope.row[index].replace(/^[1-9]{1}[0-9]*$/, "");
      scope.row[index] = scope.row[index].replace(/[^\d]/g, "");
      if (index === "notifyAdvanceDay" && scope.row["notifyAdvanceDay"] == 0) {
        this.$message.error("请填写大于0的天数");
        return;
      } else {
        scope.row["notifyAdvanceDay_"] = scope.row["notifyAdvanceDay"];
      }
      this.updateRow(scope.row);
    },
    // ^[1-9]\d*$
    // filterInput_(scope,index){
    //     console.log('666');
    //     scope.row[index]=scope.row[index].replace(/^[1-9]\d*$/g,'');
    //     this.updateRow(scope.row);
    // },

    // filterInput(scope){
    //     console.log('666');
    //     scope.row.notifyAdvanceDay=scope.row.notifyAdvanceDay.replace(/[^0-9_]/g,'');
    //     this.updateRow(scope.row);
    // },

    changeProject(val) {
      if (!val) {
        return;
      }
      this.showTable = false;
      getList({ projectId: val }).then((res) => {
        console.log("res1111111111111111111111111");
        console.log(res);
        if (res.data.records.length > 0) {
          this.contractAlertList = res.data.records;

          this.contractAlertList.forEach((ele, index) => {
            this.contractAlertList[index].notifyFlag_ = this.transferBoolean(
              this.contractAlertList[index].notifyFlag
            );
            this.contractAlertList[index].wx = this.getWx(
              this.contractAlertList[index].notifyWays
            );
            this.contractAlertList[index].sys = this.getSys(
              this.contractAlertList[index].notifyWays
            );
            this.contractAlertList[index].text = this.getText(
              this.contractAlertList[index].notifyWays
            );
            this.contractAlertList[
              index
            ].notifyAdvanceDay_ = this.contractAlertList[
              index
            ].notifyAdvanceDay;
            this.contractAlertList[
              index
            ].notifyUserIds_ = this.getNotifyUserIds(
              this.contractAlertList[index].notifyUserIds
            );
          });
          console.log(this.contractAlertList);
          this.contractAlertList = this.deepClone(this.contractAlertList);

          getProjectUserList({ projectId: val }).then((res) => {
            console.log(res);
            this.notifyUserList = res.data;
            this.notifyUserList = this.deepClone(this.notifyUserList);
            this.contractAlertList = this.addUserInfo(
              this.contractAlertList,
              this.notifyUserList
            );

            this.showTable = true;
              this.mainTableKey = Math.random();
          });
        } else {
          getInitList({ projectId: val }).then((response) => {
            this.contractAlertList = response.data;
            this.contractAlertList.forEach((ele, index) => {
              this.contractAlertList[index].notifyFlag_ = this.transferBoolean(
                this.contractAlertList[index].notifyFlag
              );
              this.contractAlertList[index].wx = this.getWx(
                this.contractAlertList[index].notifyWays
              );
              this.contractAlertList[index].sys = this.getSys(
                this.contractAlertList[index].notifyWays
              );
              this.contractAlertList[index].text = this.getText(
                this.contractAlertList[index].notifyWays
              );
              // this.contractAlertList[index].notifyAdvanceDay =
              this.contractAlertList[
                index
              ].notifyAdvanceDay_ = this.contractAlertList[
                index
              ].notifyAdvanceDay;
              this.contractAlertList[
                index
              ].notifyUserIds_ = this.getNotifyUserIds(
                this.contractAlertList[index].notifyUserIds
              );
            });
            console.log(this.contractAlertList);
            this.contractAlertList = this.deepClone(this.contractAlertList);

            getProjectUserList({ projectId: val }).then((res) => {
              console.log(res);
              this.notifyUserList = res.data;
              this.notifyUserList = this.deepClone(this.notifyUserList);
              this.contractAlertList = this.addUserInfo(
                this.contractAlertList,
                this.notifyUserList
              );

              this.showTable = true;
              this.mainTableKey = Math.random();
            });
          });
        }
      });
    },
    changeProjectUser(row) {
      this.updateRow(row);
    },
    updateRow(row) {
      row.notifyFlag = this.transferBooleanToInt(row.notifyFlag_);
      row.notifyWays = this.getNotifyWays(row);
      //后台返回的数据是数组,而人员选择器组件emit出来的是idsString,后台需要idsString,判断一下
      if (Array.isArray(row.userIds)) {
        row.notifyUserIds = row.userIds.join(",");
      } else {
        row.notifyUserIds = row.userIds;
      }
      updateRow(row).then((res) => {
        console.log(res);
        this.changeProject(row.projectId);
      });
    },
    getNotifyWays(val) {
      // console.log(val);
      let arr = [];
      if (val.wx) {
        arr.push("3");
      }
      if (val.sys) {
        arr.push("1");
      }
      if (val.text) {
        arr.push("2");
      }
      if (arr.length > 1) {
        arr = arr.join(",");
      } else {
        arr = arr.join("");
      }
      return arr;
    },
    getWx(list) {
      let flag = false;
      list.split(",").forEach((ele, index) => {
        if (parseInt(ele) == 3) {
          flag = true;
        }
      });
      return flag;
    },
    getSys(list) {
      let flag = false;
      list.split(",").forEach((ele, index) => {
        if (parseInt(ele) == 1) {
          flag = true;
        }
      });
      return flag;
    },
    getText(list) {
      let flag = false;
      list.split(",").forEach((ele, index) => {
        if (parseInt(ele) == 2) {
          flag = true;
        }
      });
      return flag;
    },
    transferBooleanToInt(val) {
      if (val) {
        // if(parseInt(val)>0){
        //     return true;
        // }else{
        //     return false;
        // }
        return 1;
      } else {
        return 0;
      }
    },
    transferBoolean(val) {
      if (val) {
        if (parseInt(val) > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
};
</script>

<style>
</style>
<style lang='scss' scoped>
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 1px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>
